import React from 'react';
import { styles } from './SupportCategory.css';
import { Link } from '../../PlatformFunctionality';

export interface SupportCategoryProps {
  title: string;
  handle?: string;
  sections: Array<{
    title: string;
    url: string;
    articles: Array<{
      title: string;
      url: string;
    }>;
    nestedSubCategories: Array<{
      title: string;
      url: string;
    }>;
  }>;
  maxArticlesToShow?: number;
}

export const SupportCategory = ({ title, sections, maxArticlesToShow = 6, handle }: SupportCategoryProps) => {
  const MAX_ARTICLES =
    sections?.length > 1
      ? maxArticlesToShow
      : sections?.[0]?.nestedSubCategories?.length
      ? sections[0].nestedSubCategories.length
      : sections?.[0]?.articles?.length ?? 0;
  const isSingleCategory = sections?.length === 1 && handle === sections[0]?.url;
  return (
    <div className={styles.mainContainer}>
      <h1>{title}</h1>
      <div className={styles.subCategoryContainer}>
        {sections?.map((subCategory, index) => (
          <div key={`subCategory-${index}`} data-test-id="support-sub-category">
            {!isSingleCategory ? (
              <Link
                key={subCategory.title}
                href={subCategory?.url}
                className={styles.link}
                data-test-id="support-sub-category-link"
              >
                <h2 className={styles.subCategoryTitle}>{subCategory?.title}</h2>
              </Link>
            ) : null}
            {subCategory?.articles?.length === 0 && subCategory?.nestedSubCategories?.length === 0 ? (
              <div>No contents available</div>
            ) : null}
            <ul className={styles.categoryContentContainer}>
              {subCategory?.nestedSubCategories?.length
                ? subCategory.nestedSubCategories.slice(0, MAX_ARTICLES).map((nested, index) => (
                    <li key={`nested-category-${index}`} className={styles.content}>
                      <Link href={nested.url} className={styles.link} data-test-id="support-article-link">
                        {nested.title}
                      </Link>
                    </li>
                  ))
                : subCategory?.articles?.slice(0, MAX_ARTICLES).map((article, index) => (
                    <li key={`article-${index}`} className={styles.content}>
                      <Link href={article.url} className={styles.link} data-test-id="support-article-link">
                        {article.title}
                      </Link>
                    </li>
                  ))}
            </ul>
            {subCategory.nestedSubCategories?.length > MAX_ARTICLES ||
            (!subCategory.nestedSubCategories?.length && subCategory.articles?.length > MAX_ARTICLES) ? (
              <Link
                data-test-id="support-article-show-more"
                className={styles.showMoreLink}
                type="link"
                href={subCategory?.url}
              >
                View all
              </Link>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};
